// extracted by mini-css-extract-plugin
export var layoutHeader = "layout-module--layoutHeader--1Ndlw";
export var layoutFooter = "layout-module--layoutFooter--S1mKo";
export var layoutMain = "layout-module--layoutMain--zqbxZ";
export var featuredImage = "layout-module--featuredImage--Mzul3";
export var grid = "layout-module--grid--TE6LR";